import { lazy } from 'react';

import type { ProjectType } from '@app/features/project';
import { ReactWebComponent } from '@app/utils/web-components';
import type { CustomTranslationStatus } from './ImportConfiguration';
import type { ImportOptions } from './events/events';

const AppProviders = lazy(() => import('@app/components/AppProviders'));
const ImportConfiguration = lazy(() => import('./ImportConfiguration'));

class ImportConfigurationComponent extends ReactWebComponent {
    static get observedAttributes() {
        return [
            'project-id',
            'project-type',
            'tags',
            'default-options',
            'custom-translation-statuses',
            'has-automations',
        ];
    }

    render() {
        const projectId = this.prop('project-id');
        const projectType = this.prop('project-type') as ProjectType;
        const tags = this.jsonProp<string[]>('tags') ?? [];
        const defaultOptions = this.jsonProp<ImportOptions>('default-options') ?? {};
        const customTranslationStatuses = this.jsonProp<CustomTranslationStatus[]>('custom-translation-statuses') ?? [];
        const hasAutomations = this.prop('has-automations') === 'true';

        return (
            <AppProviders>
                <ImportConfiguration
                    projectId={projectId}
                    projectType={projectType}
                    tags={tags}
                    defaultOptions={defaultOptions}
                    customTranslationStatuses={customTranslationStatuses}
                    hasAutomations={hasAutomations}
                />
            </AppProviders>
        );
    }
}

customElements.define('import-configuration', ImportConfigurationComponent);
